import React, { useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../dropdown'
import DropZone from '../../dropzone';
import { FormSelectYesNo,  FormInputText, DateSelector, FormTextArea } from '../formelements'
import { ContacteEmergencia } from './contacteEmergencia'



//import { useDropzone } from 'react-dropzone'
import axios from 'axios';
import config from '../../../config'
import { trobaCursPerCodi } from '../../utils'



export function EnrolmentFormPersonalData(props) {

  /* DADES GENERALS */
  const [ errors, setErrors ] = useState({});
  const [ errorValidacioIDdocument, setErrorValidacioIDdocument ] = useState();
  // fet (true/false) que el DNI NO consta al llistat de documentsadmesos, independent de si
  // això s'arriba a mostrar com a error (amb validaIDdocumentsFalsePermetMatricular no es
  // mostra ni bloqueja, però aquest fet segueix calent per desactivar MONOGRAFICS més endavant)
  const [ iddocumentNoAdmes, setIddocumentNoAdmes ] = useState(false);

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  const [dadesPersonals, setDadesPersonals ] = useState({validat: false});

  const today = new Date()
  const year = today.getFullYear()

  // gent que faci els 12 dins l'any - 1r ESO
  const any_12 = new Date( year - 12, 11, 31)

  // gent que faci els 18 dins l'any - majors edat
  const any_18 = new Date( year - 18, today.getMonth(), today.getDate()  )
  
  
  let any 
  switch(config.anysDefecte)
  {
    case 18:  any = any_18; break;
    default:
      case 12:  any = any_12
    }
    
  //console.log("ANY",any,any_18,any_12)
  let defaultDate = new Date(any)
  let maxDate = new Date(any_12)
  let minDate = new Date("1940-1-1")


  /* DADES PERSONALS */
  const [dadesIdentificativesOpen, setDadesIdentificativesOpen] = useState(true)
  const toggleOpen = () => {

    // si passa de tancat a obert invalidem apartats següents
    if(!dadesIdentificativesOpen)
    {
        setDadesPersonals(false)
        handleDadesPersonals(false)

        handleDadesMediques(false)
        setDadesMediquesOpen(false)
        setDadesMediques(false)

        handleDadesLaborals(false)
        setDadesLaboralsOpen(false)
        setDadesLaborals(false)
    }

    setDadesIdentificativesOpen(!dadesIdentificativesOpen)
  }

  const [nom, setNom] = useState('');
  const [nomSentit, setNomSentit] = useState('');
  const [cognom1, setCognom1] = useState('');
  const [cognom2, setCognom2] = useState('');
  const [tipusDoc, setTipusDoc] = useState('DNI');
  const [iddocument, setIDDocument] = useState('');
  const [iddocumentFrontFile, setIDDocumentFrontFile] = useState();
  const [iddocumentBackFile, setIDDocumentBackFile] = useState();
  const [fotoCarnetFile, setFotoCarnetFile] = useState();
  const [sexe, setSexe] = useState('');
  const [dataNaixement, setDataNaixement] = useState()
  const [dataNaixementCanviada, setDataNaixementCanviada] = useState(false)
  const [majorEdat, setMajorEdat] = useState();
  const [edat, setEdat] = useState();
  const [llibreFamiliaFile, setLlibreFamiliaFile] = useState();
  const [llibreFamiliaAlumneFile, setLlibreFamiliaAlumneFile] = useState();
  const [comunicacioProgenitors, setComunicacioProgenitors] = useState();

  const [progenitor1Nom, setProgenitor1Nom] = useState('');
  const [progenitor1Conviu, setProgenitor1Conviu] = useState('');
  const [progenitor1iddocument, setProgenitor1iddocument] = useState('');
  const [progenitor1IDFrontFile, setProgenitor1IDFrontFile] = useState();
  const [progenitor1IDBackFile, setProgenitor1IDBackFile] = useState();
  const [progenitor1Telefon, setProgenitor1Telefon] = useState('');
  const [progenitor1Email, setProgenitor1Email] = useState('');
  const [progenitor1Observacions, setProgenitor1Observacions] = useState('');

  const [progenitor2Nom, setProgenitor2Nom] = useState();
  const [progenitor2Conviu, setProgenitor2Conviu] = useState('');
  const [progenitor2iddocument, setProgenitor2iddocument] = useState();
  const [progenitor2IDFrontFile, setProgenitor2IDFrontFile] = useState();
  const [progenitor2IDBackFile, setProgenitor2IDBackFile] = useState();
  const [progenitor2Telefon, setProgenitor2Telefon] = useState();
  const [progenitor2Email, setProgenitor2Email] = useState('');
  const [progenitor2Observacions, setProgenitor2Observacions] = useState();

  const [contacteEmergenciaNom, setContacteEmergenciaNom] = useState('');
  const [contacteEmergenciaRelacio, setContacteEmergenciaRelacio] = useState();
  const [contacteEmergenciaTelefon, setContacteEmergenciaTelefon] = useState('');

  const [adreca, setAdreca] = useState('');
  const [codiPostal, setCodiPostal] = useState('');
  const [poblacio, setPoblacio] = useState('');
  const [provincia, setProvincia] = useState('');
  const [pais, setPais] = useState('Espanya');

  const [poblacioNaixement, setPoblacioNaixement] = useState('');
  const [provinciaNaixement, setProvinciaNaixement] = useState('');
  const [paisNaixement, setPaisNaixement] = useState('Espanya');
  const [nacionalitat, setNacionalitat] = useState('Espanyola');
  const [idalu, setIdalu] = useState('');

  const [telefonFix, setTelefonFix] = useState('');
  const [telefonMobil, setTelefonMobil] = useState('');

  const [telefonFixObligatori, setTelefonFixObligatori] = useState(false);
  const [telefonMobilObligatori, setTelefonMobilObligatori] = useState(false);

  const [email, setEmail] = useState('');

  const [cursObligatori, setCursObligatori ] = useState();

  // curs de monogràfic (admès via documentsadmesos/chkiddoc): a diferència de
  // mediques/laborals/progenitors (que sí que es defineixen per curs a les dades de
  // families), aquest criteri NO depèn de dades externes, es fa directament pel prefix del
  // curs, igual que ja es fa a authorizations/artlaindustrial/index.js. Quan hi ha diversos
  // cursos admesos (array), n'hi ha prou que un comenci per "MONO" (documentsadmesos només
  // s'utilitza per a monogràfics)
  const esMonografic = Array.isArray(cursObligatori)
    ? cursObligatori.some((c) => c?.startsWith("MONO"))
    : cursObligatori?.startsWith("MONO")

  const [tornObligatori, setTornObligatori ] = useState();
  const [becat, setBecat] = useState();
  // quan el DNI està admès a més d'un curs monogràfic (chkiddoc torna "cursos" en lloc
  // d'un únic "c"): llista [{c,t,b}] amb els cursos admesos, perquè l'step d'Estudis
  // deixi triar entre aquests en lloc de forçar-ne un de sol
  const [cursosAdmesos, setCursosAdmesos] = useState();
  const [apartatsOmesos, setApartatsOmesos] = useState([]);
  const [apartatsAddicionals, setApartatsAddicionals] = useState([]);
  const [adjuntarArxiusNoObligatori, setAdjuntarArxiusNoObligatori] = useState(config.adjuntarArxiusNoObligatori === true);
  const [noPreguntarSiEsNouAlumne, setNoPreguntarSiEsNouAlumne] = useState(config.noPreguntarSiEsNouAlumne === true);
  const [matriculaDirecta, setMatriculaDirecta] = useState(false);

  useEffect(() => {

    // el DNI té un curs obligatori (documentsadmesos): les particularitats (apartats a ometre, apartats
    // addicionals a mostrar, si és un curs de continuïtat...) venen del propi curs, no d'una fase manual
    // per a tot el centre. Quan hi ha diversos cursos admesos (array) encara no sabem quin triarà
    // l'alumne a l'step d'Estudis: agafem el primer com a representatiu (en la pràctica els
    // monogràfics comparteixen aquesta configuració)
    if (cursObligatori) {
      const primerCursObligatori = Array.isArray(cursObligatori) ? cursObligatori[0] : cursObligatori
      const curs = trobaCursPerCodi(props.families, primerCursObligatori)
      setApartatsOmesos(curs?.apartatsOmesos || [])
      setApartatsAddicionals(curs?.apartatsAddicionals || [])
      setAdjuntarArxiusNoObligatori(curs?.adjuntarArxiusNoObligatori === undefined ? config.adjuntarArxiusNoObligatori === true : curs.adjuntarArxiusNoObligatori === true)
      setNoPreguntarSiEsNouAlumne(curs?.noPreguntarSiEsNouAlumne === undefined ? config.noPreguntarSiEsNouAlumne === true : curs.noPreguntarSiEsNouAlumne === true)
      // cursos amb matrícula directa (p.ex. monogràfics): no cal preguntar si és nou al centre
      // (es dona per fet que sí), ni aportar preinscripció, títol, notes o dades d'estudis previs
      setMatriculaDirecta(curs?.matriculaDirecta === true)
      return
    }

    // matrícula lliure (no hi ha curs obligatori): s'apliquen els valors per defecte del centre
    setApartatsOmesos(config.apartatsOmesosPerDefecte || [])
    setApartatsAddicionals(config.apartatsAddicionalsPerDefecte || [])
    setAdjuntarArxiusNoObligatori(config.adjuntarArxiusNoObligatori === true)
    setNoPreguntarSiEsNouAlumne(config.noPreguntarSiEsNouAlumne === true)
    setMatriculaDirecta(false)

  }, [props.families, cursObligatori])

  const [NESEYN, setNESEYN] = useState();
  const [NESE, setNESE] = useState();
  const [NESEObservacions, setNESEObservacions] = useState();
  const [necessitatsEducativesEspecialsFile, setNecessitatsEducativesEspecialsFile] = useState();
  const [carnetFamiliaNombrosaFile, setCarnetFamiliaNombrosaFile] = useState();

  const [germansAlCentre, setGermansAlCentre ] = useState();

  // secció addicional "coneixementsPrevis" (només es mostra si el curs la té marcada a apartatsAddicionals)
  const [haFetAltreCursCentre, setHaFetAltreCursCentre] = useState();
  const [teConeixementsPrevis, setTeConeixementsPrevis] = useState();

  const [llenguesEntenc, setLlenguesEntenc ] = useState();
  const [llenguesUsHabitual, setLlenguesUsHabitual ] = useState();
  const [llenguesUsFamiliar, setLlenguesUsFamiliar ] = useState();

  const [plaIndividualitzat, setPlaIndivitualitzat] = useState('');

  const handleBlurIDDocument = (e) => 
  {
    //let error = {};

    //TODO error.iddocument = validaIDDocument(e);

    validaIDDocument(e);

    //console.log("blur ID",error, e);
    //console.log("blur ID", e);

    return true;
  }

  const handleChangeDataNaixement = (dataNaixementNova) => {
    //console.log("data naixement canviada",dataNaixementNova)
    setDataNaixement(dataNaixementNova)
    setDataNaixementCanviada(true)
  }


  /* DADES MEDIQUES */
  const [dadesMediquesOpen, setDadesMediquesOpen] = useState(false);
  const toggleDadesMediquesOpen = () => {
    setDadesMediquesOpen(!dadesMediquesOpen);
  }

  const [dadesMediques, setDadesMediques] = useState({validat: false});

  /* VALIDA DADES PERSONALS */
  const validaNom = () => {
    return nom.length > 0 ? null : "El nom no pot estar buit"
  }

  const validaNomSentit = () => {
    return nomSentit.length > 0 ? null : "El nom sentit no pot estar buit"
  }

  const validaCognom1 = () => {
    return cognom1.length > 0 ? null : "El camp Primer Cognom no pot estar buit"
  }

  const validaSexe = () => {
    return sexe.length > 0 ? null : "Heu d'indicar un sexe"
  }

  const validaStringNoBuit = (camp, errormsg) => {
    return camp.length > 0 ? null : errormsg;
  }

  const validaAdreca = () => {
    return validaStringNoBuit(adreca, "El camp adreça no pot estar buit");
  }

  const validaCodiPostal = () => {
    return validaStringNoBuit(codiPostal, "El camp codi postal no pot estar buit");
  }

  const validaPoblacio = () => {
    return validaStringNoBuit(poblacio, "El camp població no pot estar buit");
  }

  const validaProvincia = () => {
    return validaStringNoBuit(provincia, "El camp provincia no pot estar buit");
  }

  const validaPais = () => {
    return validaStringNoBuit(pais, "El camp país no pot estar buit");
  }

  const validaPoblacioNaixement = () => {
    return validaStringNoBuit(poblacioNaixement, "El camp població no pot estar buit");
  }

  const validaProvinciaNaixement = () => {
    return validaStringNoBuit(provinciaNaixement, "El camp provincia no pot estar buit");
  }

  const validaPaisNaixement = () => {
    return validaStringNoBuit(paisNaixement, "El camp país no pot estar buit");
  }

  const validaNacionalitat= () => {
    return validaStringNoBuit(nacionalitat, "El camp nacionalitat no pot estar buit");
  }

  const validaIDALU = () => {
    return validaStringNoBuit(idalu, "El camp IDALU no pot estar buit");
  }

  const validaPlaIndividualitzat = () => {
    return plaIndividualitzat.length > 0 ? null : "Heu d'indicar una opció"
  }

  const validaIDDocumentDB = async (d) => {

  try 
   {

    const dadesPost = {
      cid: config.cid,
      act: 'chkiddoc',
      iddocument: d,
    }

    const headers = { 'Content-Type': 'multipart/form-data' }

      //axios.post(config.apiURL, dadesPost, headers)
      const response = await axios.post("/api/", dadesPost, headers);

      if(response.data.cursos)
      {
        // el DNI està admès a més d'un curs: no forcem cap torn/becat/curs fix, es
        // deixa la llista perquè l'alumne triï entre els seus cursos admesos
        setCursosAdmesos(response.data.cursos)
        setCursObligatori(response.data.cursos.map((c) => c.c))
        setTornObligatori()
        setBecat()
      }
      else
      {
        // comportament de sempre: DNI admès (com a molt) a un únic curs, es força directament
        setCursosAdmesos()
        // si amb el DNI hi ha torn i curs obligatori els posem per a forcar la tria
        if(response.data.t) { setTornObligatori(response.data.t)} else { setTornObligatori()}
        if(response.data.c) { setCursObligatori(response.data.c)} else { setCursObligatori() }
        if(response.data.b) { setBecat(response.data.b)} else { setBecat()}
      }

      const trobat = response.data.r === 1
      setIddocumentNoAdmes(!trobat)

      // amb validaIDdocumentsFalsePermetMatricular, un DNI no trobat NO es mostra com a
      // error ni bloqueja la matrícula (es permet continuar amb normalitat); el fet queda
      // igualment registrat a iddocumentNoAdmes per desactivar MONOGRAFICS al selector de
      // cicles (veure formelements.js FormSelectCicle)
      setErrorValidacioIDdocument(
        trobat || config.validaIDdocumentsFalsePermetMatricular
          ? null
          : "Document no trobat al llistat de matriculables. Contacteu amb secretaria."
      )
      return false
    }
    catch (err) {
      //console.log(err)
      return false;
    };
    
  }


  const handleTelefonObligatori = ()  => {

    //console.log("TEL OBL")

    // als monogràfics cal com a mínim un telèfon de l'alumne encara que sigui menor d'edat
    if(majorEdat || esMonografic) {
      setTelefonFixObligatori(true)
      setTelefonMobilObligatori(true)

    //console.log("TEL OBL","MAJOR EDAT SI")

      // Si han omplert una de les dues l'altra no és obligatori
      if( telefonFix.length )
      {
        setTelefonMobilObligatori(false)
    //console.log("TEL OBL","FIX PLE MOB OPT")
      }

      if( telefonMobil.length )
      {
        setTelefonFixObligatori(false)
    //console.log("TEL OBL","MOBIL PLE FIX OPT")
      }

    } else {

    //console.log("TEL OBL","MAJOR EDAT NO")
      setTelefonMobilObligatori(false)
      setTelefonFixObligatori(false)
    }

  }


  const handleTelefonFix = (e) => {

    setTelefonFix(e)

  }

  const handleTelefonMobil= (e) => {

    setTelefonMobil(e)

  }





  useEffect(() => {

    // telefon obligatori per majors edat (o per monogràfics, siguin quina sigui l'edat)
    handleTelefonObligatori()

  }, [dataNaixement,telefonFix,telefonMobil,esMonografic])




  const validaIDDocument = (e) => {

      let error = {}
      // si tornem a comprovar eliminem error prèvi
    if (config.validaIDdocuments) {
      setErrorValidacioIDdocument("")
    }

  //console.log(":: -1",e)

    let d;

    if(e)
    {
      d = e.toUpperCase().trim()
    }
    else
    {
      d = iddocument.toUpperCase().trim()
    }

    
    if(!d.length > 0)
    {
      return "El camp no pot estar buit."
    }
    
    setIDDocument(d)

    if (tipusDoc === "DNI") {
      if(!/^[0-9]{8}[A-Z]$/.test(d)) 
      {
        return "El format de DNI no és vàlid."
      }
    }

    if (config.validaIDdocuments) {
      validaIDDocumentDB(d)
    }

    return null
  }

  const validaIDDocumentFrontFile = () => {

    if(adjuntarArxiusNoObligatori) return null

    return iddocumentFrontFile ? null : "El camp no pot estar buit."
  }

  const validaIDDocumentBackFile = () => {

    if(adjuntarArxiusNoObligatori) return null

    return iddocumentBackFile ? null : "El camp no pot estar buit."
  }

  const validaFotoCarnetFile = () => {

    if(adjuntarArxiusNoObligatori) return null

    // si no cal foto carnet valida sempre
    if(!config.fotoCarnet) return null

    return fotoCarnetFile ? null : "El camp no pot estar buit."
  }

  const validaProgenitor1Nom = () => {
    return progenitor1Nom.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Conviu = () => {
    return progenitor1Conviu !== "" ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1iddocument= () => {
    return progenitor1iddocument.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1FrontFile = () => {

    if(adjuntarArxiusNoObligatori) return null

    return progenitor1IDFrontFile ? null : "El camp no pot estar buit."
  }

  const validaProgenitor1BackFile = () => {

    if(adjuntarArxiusNoObligatori) return null

    return progenitor1IDBackFile ? null : "El camp no pot estar buit."
  }

  const validaProgenitor1Telefon = () => {
    return progenitor1Telefon.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Email = () => {
      return validaEmail(progenitor1Email);
    //return progenitor1Email.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor1Observacions = () => {
    return progenitor1Observacions.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2Nom = () => {
    return progenitor1Nom.length > 0 ? null : "El nom no pot estar buit"
  }

  const validaProgenitor2Telefon = () => {
    return progenitor2Telefon.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaProgenitor2Email = () => {

     // no obligatori pero si l'han posat comprovem format correcte
    if(progenitor2Email.length)
    {
      return validaEmail(progenitor2Email);
    }

    return null
  }

  const validaProgenitor2Observacions = () => {
    return progenitor2Observacions.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaComunicacioProgenitors = () => {
    if (majorEdat) {
      return comunicacioProgenitors ? null : "Cal triar un valor"
    }

    return null
  }

  const validaContacteEmergenciaNom = () => {
    return contacteEmergenciaNom.length > 0 ? null : "El camp no pot estar buit"
  }

  const validaContacteEmergenciaRelacio = () => {
      return contacteEmergenciaRelacio ? null : "Cal triar un valor"
  }

  const validaContacteEmergenciaTelefon = () => {
    return contacteEmergenciaTelefon.length > 0 ? null : "El camp no pot estar buit"
  }


  const validaTelefons = () => {

    if(!config.telefonObligatori) return null

    // als monogràfics cal com a mínim un telèfon de l'alumne encara que sigui menor d'edat
    if (majorEdat || esMonografic) {

      if( !telefonFix.length && !telefonMobil.length )
      {
        return "S'ha de proporcionar al menys un telèfon"
      }

    }

    return null
  }

  const validaEmail = (e) => {

      if(!e.length)
      {
          return "El camp email no pot estar buit"
      }

      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if(!pattern.test(e))
      {
       return "No és un format d'email vàlid"
      }

    return null
  }

  const validaGermansAlCentre = () => {
      return germansAlCentre ? null : "Cal triar una opció"
  }

  const validaHaFetAltreCursCentre = () => {
      return haFetAltreCursCentre ? null : "Cal triar una opció"
  }

  const validaTeConeixementsPrevis = () => {
      return teConeixementsPrevis ? null : "Cal triar una opció"
  }

  const validaLlenguesEntenc = () => {
      return llenguesEntenc ? null : "Cal triar una opció"
  }

  const validaLlenguesUsFamiliar = () => {
      return llenguesUsFamiliar ? null : "Cal triar una opció"
  }

  const validaLlenguesUsHabitual = () => {
      return llenguesUsHabitual ? null : "Cal triar una opció"
  }

  const validaNESE = () => {
      return NESE && NESE !== "" ? null : "Cal triar una opció"
  }

  const validaNESEObservacions = () => {
      return NESEObservacions?.length ? null : "Cal especificar"
  }

  const validaNecessitatsEducativesEspecialsFile = () => {
      return necessitatsEducativesEspecialsFile ? null : "Cal adjuntar document"
  }



  const valida = (e) => {

    e.preventDefault();

    handleTelefonObligatori()

    let error = {}

    // abans de validar eliminem errors anteriors
    setErrors(error)

    //TODO ERROR
    error.iddocument = validaIDDocument()

    handleErrors('iddocument', error)

    error.nom = validaNom();

    handleErrors('nom', validaNom())

    error.cognom1 = validaCognom1();

    handleErrors('cognom1', error)

    error.dataNaixement = validaDataNaixement()

    handleErrors('dataNaixement', validaDataNaixement())

    error.telefon = validaTelefons();
    handleErrors('telefon', error)

    //if (majorEdat || email.length) {
      error.email = validaEmail(email);
      handleErrors('email', error)

    if (!esMonografic) {
      error.pais = validaPais();
      handleErrors('pais', error)

      error.provincia = validaProvincia();
      handleErrors('provincia', error)
    }

    error.poblacio = validaPoblacio();
    handleErrors('poblacio', error)

    if (!esMonografic) {
      error.paisNaixement = validaPaisNaixement();
      handleErrors('paisNaixement', error)

      error.provinciaNaixement = validaProvinciaNaixement();
      handleErrors('provinciaNaixement', error)

      error.poblacioNaixement = validaPoblacioNaixement();
      handleErrors('poblacioNaixement', error)
    }

    error.nacionalitat = validaNacionalitat();
    handleErrors('nacionalitat', error)

    /*
    error.idalu = validaIDALU();
    handleErrors('idalu', error)
    */

    error.codiPostal = validaCodiPostal();

    handleErrors('codiPostal', error)

    error.adreca = validaAdreca();

    handleErrors('adreca', error)

    //errors.tipusDoc = validaTipusDoc(tipusDoc)


    if ( tipusDoc !== "PRE" && !esMonografic) {

      error.iddocumentFrontFile = validaIDDocumentFrontFile()

      handleErrors('iddocumentFrontFile', error)

      error.iddocumentBackFile = validaIDDocumentBackFile()
    }

    if (config.fotoCarnet && !esMonografic) {
    handleErrors('fotoCarnetFile', error)

    error.fotoCarnetFile = validaFotoCarnetFile()
    }

    handleErrors('iddocumentBackFile', error)

    if (!esMonografic) {
      error.sexe = validaSexe(sexe)
    }


    //console.log("CONTACTE",config.contacteEmergenciaObligatori)

    if ( !esMonografic && config.contacteEmergenciaObligatori && majorEdat ) {

      error.contacteEmergenciaNom = validaContacteEmergenciaNom()
      handleErrors('contacteEmergenciaNom', error)

      error.contacteEmergenciaRelacio = validaContacteEmergenciaRelacio()
      handleErrors('contacteEmergenciaRelacio', error)

      error.contacteEmergenciaTelefon = validaContacteEmergenciaTelefon()
      handleErrors('contacteEmergenciaTelefon', error)

    }


    if (majorEdat && !esMonografic) {

      error.comunicacioProgenitors = validaComunicacioProgenitors()

      handleErrors('comunicacioProgenitors', error)

    }
    else if (!apartatsOmesos.includes('progenitors')) {

        error.progenitor1Nom = validaProgenitor1Nom()
        handleErrors('progenitor1Nom', error)

        /* No comprobable
        if(config.conviuAmbProgenitor)
        {
          error.progenitor1Conviu = validaProgenitor1Conviu()
          handleErrors('progenitor1Conviu', error)
        }*/

        error.progenitor1iddocument= validaProgenitor1iddocument()
        handleErrors('progenitor1iddocument', error)

        error.progenitor1IDFrontFile = validaProgenitor1FrontFile()
        handleErrors('progenitor1IDFrontFile', error)

        error.progenitor1IDBackFile = validaProgenitor1BackFile()
        handleErrors('progenitor1IDBackFile', error)

        error.progenitor1Telefon = validaProgenitor1Telefon()
        handleErrors('progenitor1Telefon', error)

        error.progenitor1Email = validaProgenitor1Email()
        handleErrors('progenitor1Email', error)

        error.progenitor1Observacions = validaProgenitor1Observacions()
        handleErrors('progenitor1Observacions', error)

        error.progenitor2Email = validaProgenitor2Email()
        handleErrors('progenitor2Email', error)

      }

    if (config.validaTelefonsDuplicats &&  !majorEdat) {

      let telefons = []

      if (telefonFix?.length) telefons.push(telefonFix.trim().replace(/\D/g, ''))
      if (telefonMobil?.length) telefons.push(telefonMobil.trim().replace(/\D/g, ''))
      if (progenitor1Telefon?.length) telefons.push(progenitor1Telefon.trim().replace(/\D/g, ''))
      if (progenitor2Telefon?.length) telefons.push(progenitor2Telefon.trim().replace(/\D/g, ''))

      const hasDuplicates = new Set(telefons).size !== telefons.length;
      
      if(hasDuplicates) {

      error.telefon = "Algun dels telèfons proporcionats està duplicat, indiqueu telèfons de contacte diferents per a cada camp."
      if (progenitor1Telefon?.length) error.progenitor1Telefon = error.telefon
      if (progenitor2Telefon?.length) error.progenitor2Telefon = error.telefon

      handleErrors('telefon', error)
      }
    }



    if(config.germansAlCentre)
    {
      error.germansAlCentre = validaGermansAlCentre()
      handleErrors('germansAlCentre', error)
    }

    if(apartatsAddicionals.includes('coneixementsPrevis'))
    {
      error.haFetAltreCursCentre = validaHaFetAltreCursCentre()
      handleErrors('haFetAltreCursCentre', error)

      error.teConeixementsPrevis = validaTeConeixementsPrevis()
      handleErrors('teConeixementsPrevis', error)
    }

    if(config.llengues)
    {
      error.llenguesEntenc = validaLlenguesEntenc()
      handleErrors('llenguesEntenc', error)

      error.llenguesUsHabitual = validaLlenguesUsHabitual()
      handleErrors('llenguesUsHabitual', error)

      error.llenguesUsFamiliar = validaLlenguesUsFamiliar()
      handleErrors('llenguesUsFamiliar', error)
    }



    if (!esMonografic && NESEYN === "1") // marcada opció NESE
    {

      error.NESE = validaNESE()
      handleErrors('NESE', error)

      if(NESE === "altres") // opció altres necessita text especific
      {

        error.NESEObservacions = validaNESEObservacions()
        handleErrors('NESEObservacions', error)

      }

      error.necessitatsEducativesEspecialsFile = validaNecessitatsEducativesEspecialsFile()
      handleErrors('necessitatsEducativesEspecialsFile', error)

    }


    if (!esMonografic) {
      error.plaIndividualitzat = validaPlaIndividualitzat()
      handleErrors('plaIndividualitzat', error)
    }



    setErrors(error)

    //console.log('errors', errors)

    let noError = true;
    //DEVELOP if (window.location.hostname !== "localhost" ) 
    if(!config.develop) // bypass errors if develop == true
    {
     Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
    }

    handleDadesPersonals(noError)

    if(noError)
    {

        if(!config.develop){ // bypass errors if develop == true
          // amb validaIDdocumentsFalsePermetMatricular, errorValidacioIDdocument mai arriba
          // a marcar-se (veure validaIDDocumentDB), així que aquí ja no bloqueja per si sol
          if (config.validaIDdocuments) {
            //console.log("VALIDA",errorValidacioIDdocument);
              if(errorValidacioIDdocument !== null ) {
              // console.log("NO VALIDAT");
                return false;}
          }
        }

      //console.log("VALIDAT",noError,error)

        setDadesIdentificativesOpen(false)
        setDadesMediquesOpen(true)
        setDadesLaboralsOpen(false)
    }

    return false;
  }


  const handleFileError = (e,msg) => {
    let err  = {...errors}
    err[e] = msg 
    setErrors(err)
  }


  useEffect(() => {

    // calculem edat/majorEdat de seguida (calen per mostrar/amagar altres camps),
    // però no marquem l'error del camp fins que l'usuari intenti avançar de secció
    // (això ja ho fa la validació del botó SEGÜENT)
    validaDataNaixement();

    let dadesPersonals = { ...props.dadesPersonals }

    dadesPersonals.dataNaixement = dataNaixement;

    props.handleDadesPersonals(dadesPersonals)

  }, [dataNaixement])


  const handleDadesPersonals = (noError) => {

  let d = {
  "validat": noError,
  "nom": nom , 
  "nomSentit": nomSentit , 
  "cognom1": cognom1 , 
  "cognom2": cognom2 , 
  "tipusDoc": tipusDoc , 
  "iddocument": iddocument , 
  "iddocumentFrontFile": iddocumentFrontFile , 
  "iddocumentBackFile": iddocumentBackFile , 
  "fotoCarnetFile": fotoCarnetFile, 
  "sexe": sexe , 
  "dataNaixement": dataNaixement , 
  "majorEdat": majorEdat , 
  "edat": edat, 
  "llibreFamiliaFile": llibreFamiliaFile , 
  "llibreFamiliaAlumneFile": llibreFamiliaAlumneFile , 
  "comunicacioProgenitors": comunicacioProgenitors , 

  "progenitor1Nom": progenitor1Nom , 
  "progenitor1iddocument": progenitor1iddocument, 
  "progenitor1Conviu": progenitor1Conviu, 
  "progenitor1IDFrontFile": progenitor1IDFrontFile , 
  "progenitor1IDBackFile": progenitor1IDBackFile , 
  "progenitor1Telefon": progenitor1Telefon , 
  "progenitor1Email": progenitor1Email , 
  "progenitor1Observacions": progenitor1Observacions , 

  "progenitor2Nom": progenitor2Nom , 
  "progenitor2iddocument": progenitor2iddocument, 
  "progenitor2Conviu": progenitor2Conviu, 
  "progenitor2IDFrontFile": progenitor2IDFrontFile , 
  "progenitor2IDBackFile": progenitor2IDBackFile , 
  "progenitor2Telefon": progenitor2Telefon , 
  "progenitor2Email": progenitor2Email , 
  "progenitor2Observacions": progenitor2Observacions , 

  "contacteEmergenciaNom": contacteEmergenciaNom , 
  "contacteEmergenciaRelacio": contacteEmergenciaRelacio , 
  "contacteEmergenciaTelefon": contacteEmergenciaTelefon , 

  "adreca": adreca , 
  "codiPostal": codiPostal , 
  "poblacio": poblacio , 
  "provincia": provincia , 
  "pais": pais , 
  "telefonFix": telefonFix , 
  "telefonMobil": telefonMobil , 
  "email": email, 

  "tornObligatori": tornObligatori,
  "cursObligatori": cursObligatori,
  // llista [{c,t,b}] quan el DNI està admès a més d'un curs (veure validaIDDocumentDB);
  // undefined en el cas habitual (0 o 1 curs admès)
  "cursosAdmesos": cursosAdmesos,
  // DNI comprovat (validaIDdocuments) i NO trobat al llistat de documentsadmesos; amb
  // validaIDdocumentsFalsePermetMatricular la matrícula no queda bloquejada per això, però
  // l'step d'Estudis l'utilitza per desactivar sempre l'opció MONOGRAFICS al selector de cicles
  "iddocumentNoAdmes": iddocumentNoAdmes,
  "becat": becat,
  "apartatsOmesos": apartatsOmesos,
  "apartatsAddicionals": apartatsAddicionals,
  "haFetAltreCursCentre": haFetAltreCursCentre,
  "teConeixementsPrevis": teConeixementsPrevis,
  "adjuntarArxiusNoObligatori": adjuntarArxiusNoObligatori,
  "noPreguntarSiEsNouAlumne": noPreguntarSiEsNouAlumne,
  "matriculaDirecta": matriculaDirecta,

  //"NESE": NESE,
  //"NESEObservacions": NESEObservacions,
  "necessitatsEducativesEspecialsFile": necessitatsEducativesEspecialsFile,
 // "carnetFamiliaNombrosaFile": carnetFamiliaNombrosaFile,

  "plaIndividualitzat": plaIndividualitzat,

	"poblacioNaixement": poblacioNaixement,
	"provinciaNaixement": provinciaNaixement,
	"paisNaixement": paisNaixement,
	"nacionalitat": nacionalitat,
	"idalu": idalu,

  }

    //console.log("DADES_PERSONALS",d)
    setDadesPersonals(d)
    props.handleDadesPersonals(d)
  }


  /* DADES MEDIQUES */

  const handleDadesMediques = (noError) => {

  let d = { "validat": noError }

    //console.log("DADES_MEDIQUES",d)
    setDadesMediques(d)
    props.handleDadesMediques(d)
  }


// VALIDA 

  const calculaEdat = (dataNaixement) => {
        const birthDate = new Date(dataNaixement);
        const currentDate = new Date();
    
        let edat = currentDate.getFullYear() - birthDate.getFullYear();

        const monthDifference = currentDate.getMonth() - birthDate.getMonth();

        //console.log("EDAT CALC",monthDifference,edat,currentDate.getFullYear(),birthDate.getFullYear())
        if (
          monthDifference < 0 ||
          (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())
        ) {
          edat--;
        }
    
        //console.log("EDAT CALC 4",edat);
        return edat;
  }


  /* DADES LABORALS */
  const [dadesLaboralsOpen, setDadesLaboralsOpen] = useState(false);
  const toggleDadesLaboralsOpen = () => {
    setDadesLaboralsOpen(!dadesLaboralsOpen);
  }
  const [dadesLaborals, setDadesLaborals] = useState({validat: false});

  const handleDadesLaborals = (noError) => {

  let d = {  "validat": noError }

    setDadesLaborals(d)
    props.handleDadesLaborals(d)
  }




  const validaDataNaixement = () => {
    //let temps = new Date(dataNaixement)

    if(dataNaixementCanviada === false) return "Heu d'indicar la vostra data de naixement"

    if (dataNaixement) 
    {



      const edatCalc = calculaEdat(dataNaixement)

    //console.log("VALIDA DATA_NAIXE",dataNaixement,edatCalc,edatCalc >= 18)

      setEdat( edatCalc )

      setMajorEdat(edatCalc >= 18)

     // temps.setFullYear(temps.getFullYear() + 18) // 18 anys
     //setMajorEdat(new Date().getTime() >= temps.getTime())

    //console.log("EDAT",edat,edatCalc,majorEdat)
    }

    // data ok
    return null;
    // return /^[0-3][0-9]\/[0-1][0-9]\/[0-9]{4}$/.test(dataNaixement) ? null : "El format de la data no és vàlid."
  }


  return (

    <div className="container">
      <div className="row">
        <div className="col col-12 ">
            { config.pagamentTPV && ( dadesIdentificativesOpen && (
            <div style={{ textAlign: 'center', fontSize: '1.05rem'}}>Si ja heu realitzat la inscripció prèviament i només voleu realitzar el pagament podeu accedir-hi directament aquí <a href={config.urlTPV}>{config.urlTPV}</a></div>
            ))}

            { config.textIntroductori && ( dadesIdentificativesOpen && (
            <div style={{ textAlign: 'center', fontSize: '1.05rem'}}>Per realitzar la matrícula heu de tenir a mà el títol que dona accès, DNI, Targeta Sanitaria Individual (TSI) o similar, foto carnet, i altra documentació necessària`.  </div>))}
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={toggleOpen}>
                  {dadesIdentificativesOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                  {!dadesIdentificativesOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">Dades personals</h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">

              <Dropdown open={dadesIdentificativesOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">

                    <div className="row">
                      <div className="col col-12" >
                          <label className="t-Form-label">Dades de l'alumne/a:</label>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">
                                <div className="row">
                                  <div className="col col-3 ">
                                    <div
                                      className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="tipusDoc_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="tipusDoc" id="tipusDoc_LABEL"
                                          className="t-Form-label">Tipus document:</label>
                                      </div>
                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">

                                          <select id="tipusDoc" defaultValue="DNI" name="tipusDoc" className="selectlist" size="1" onChange={(e) => setTipusDoc(e.target.value)}>
                                            <option value="DNI">DNI - Document Nacional d'Identitat </option>
                                            <option value="NIE">NIE - Número d'Identificació d'Estranger</option>
                                            <option value="PASS">PASS - Passaport/Document d'un país de la comunitat Europea</option>
                                            { config.tipusDocTSI && (<option value="TSI">TSI - Targeta sanitària individual</option>) }
                                            { config.tipusDocPreInscripcio && (<option value="PRE">PRE - N. Preinscripció</option>) }
                                          </select></div>
                                        <span className="a-Form-error">{errors.tipusDoc}</span>
                                      </div>
                                    </div>
                                  </div>


                                  <FormInputText id="iddocument" name="iddocument" col="col-2" label="Número document" obligatori={true} size="20" maxLength="20" value={iddocument} onBlur={handleBlurIDDocument} onChange={setIDDocument} error={ [errors.iddocument,errorValidacioIDdocument].join(' ').trim() } />

                                  { !esMonografic && (
                                    <FormInputText id="idalu" name="idalu" col="col-1" label="IDALU" obligatori={false} size="11" maxLength="11" value={idalu} onChange={setIdalu} error={ errors.idalu } />
                                  )}

                                  { tipusDoc !== "PRE" && !esMonografic && (
                                    <>
                                      <DropZone id="iddocumentFrontFile" file={iddocumentFrontFile} col="col-2" onChange={setIDDocumentFrontFile} label={"Adjuntar document" + (adjuntarArxiusNoObligatori ? "" : "*")} labelSmall="(cara davant)" labelDrop="adjuntar imatge" error={errors.iddocumentFrontFile} handleFileError={(msg) => handleFileError('iddocumentFrontFile', msg)} />

                                      <DropZone id="iddocumentBackFile" file={iddocumentBackFile} col="col-2" onChange={setIDDocumentBackFile} label={"Adjuntar document" + (adjuntarArxiusNoObligatori ? "" : "*")} labelSmall="(cara darrera)" labelDrop="adjuntar imatge" error={errors.iddocumentBackFile} handleFileError={(msg) => handleFileError('iddocumentBackFile', msg)} />
                                    </>
                                  )}

                                 { config.fotoCarnet && !esMonografic && (<DropZone id="fotoCarnetFile" file={fotoCarnetFile} col="col-2" onChange={setFotoCarnetFile} label={"Adjuntar foto mida carnet" + (adjuntarArxiusNoObligatori ? "" : "*")} labelSmall="" labelDrop="adjuntar imatge" error={errors.fotoCarnetFile} handleFileError={ (msg) =>handleFileError('fotoCarnetFile',msg) } />)}

                                </div>
                              </div>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>

                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding margin-top-sm">


                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                <div className="row">

                                  <FormInputText id="nom" name="nom" col={"col-" + config.nomSentit ? 2 : 3} label="Nom" value={nom} obligatori={true} size="30" maxLength="50" onChange={setNom} valida={validaNom} error={errors.nom} />

                                  {config.nomSentit && (<FormInputText id="nomSentit" name="nomSentit" col="col-1" label="Nom sentit" value={nomSentit} obligatori={false} size="30" maxLength="50" onChange={setNomSentit} valida={validaNomSentit} error={errors.nomSentit} />) }

                                  <FormInputText id="cognom1" name="cognom1" col="col-3" label="Primer cognom" value={cognom1} obligatori={true} size="30" maxLength="50" onChange={setCognom1} valida={validaCognom1} error={errors.cognom1} />

                                  <FormInputText id="cognom2" name="cognom2" col="col-3" label="Segon cognom" value={cognom2} obligatori={false} size="30" maxLength="50" onChange={setCognom2} error={errors.cognom2} />

                                  { !esMonografic && (
                                  <div className="col col-1 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="sexe_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="sexe" id="sexe_LABEL" className="t-Form-label">Sexe: </label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>

                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="sexe" name="sexe" defaultValue={sexe} className="selectlist" size="1" onChange={(e) => setSexe(e.target.value)}>
                                            <option value=""></option>
                                            <option value="D" >Dona</option>
                                            <option value="H" >Home</option>
                                            { config.sexeNoBinari && (<option value="NB" >No-binari</option>)}
                                          </select></div>
                                        <span id="sexe_ERROR" className="a-Form-error">{errors.sexe}</span>
                                      </div>
                                    </div>
                                  </div>
                                  )}


                                  <div className="col col-2 ">
                                    <div id="dataNaixement" className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="dataNaixement" id="dataNaixement_LABEL" className="t-Form-label">Data Naixement (d/m/a): </label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>

                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <DateSelector selected={dataNaixement} onChange={handleChangeDataNaixement} minDate={minDate} maxDate={maxDate} />
                                        </div>

                                        <span id="dataNaixement_ERROR" className="a-Form-error">{errors.dataNaixement}</span>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                                <div className="row">

                                  {majorEdat === true && !esMonografic && (
                                  <React.Fragment>

                                    <FormSelectYesNo id="autoritzoComunicacioProgenitors"
                                      name="autoritzoComunicacioProgenitors"
                                      col="col-5"
                                      value={comunicacioProgenitors}
                                      label="Autoritzo que els meus progenitors/tutors legals puguin rebre comunicats de l'escola."
                                      obligatori={true}
                                      error={errors.comunicacioProgenitors}
                                      handleChange={(e) => setComunicacioProgenitors(e.target.value)} />


                                    <ContacteEmergencia col="col-4"
                                      label="Telèfon en cas d'emergència"
                                      values={{ nom: contacteEmergenciaNom, relacio: contacteEmergenciaRelacio, telefon: contacteEmergenciaTelefon }}
                                      onChanges={{ nom: setContacteEmergenciaNom, relacio: setContacteEmergenciaRelacio, telefon: setContacteEmergenciaTelefon }}
                                      obligatori={ config.contacteEmergenciaObligatori && majorEdat }
                                      errors={errors} />

                                  </React.Fragment>)
                                  }

                                  {majorEdat === false && !esMonografic && !apartatsOmesos.includes('progenitors') &&

                                    (<React.Fragment>
                                      <DropZone id="llibreFamiliaFile" file={llibreFamiliaFile} onChange={setLlibreFamiliaFile} label="Llibre de família" labelSmall="(plana de progenitors)" labelDrop="adjuntar imatge" error={errors.llibreFamiliaFile}  handleFileError={ (msg) =>handleFileError('llibreFamiliaFile',msg) }  />

                                      <DropZone id="llibreFamiliaAlumneFile" file={llibreFamiliaAlumneFile} onChange={setLlibreFamiliaAlumneFile} label="Llibre de família" labelSmall="(plana de l'alumne/a)" labelDrop="adjuntar imatge" error={errors.llibreFamiliaAlumneFile}  handleFileError={ (msg) =>handleFileError('llibreFamiliaAlumneFile',msg) }  />
                                      <div className="col col-3"><small>En cas de alumnat estranger sense llibre de família, adjuntar documentació pertinent.</small></div>

                                    <div className="row">
                                      <div className="col col-12" >
                                        &nbsp;
                                      </div>
                                    </div>


                                      <div className="row">
                                        <div className="col col-12" >
                                          <div className="t-Form-labelContainer">
                                            <label id="progenitor1Nom_LABEL" htmlFor="progenitor1Nom" className="t-Form-label">Dades dels progenitors / Tutors legals</label>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="row">

                                        <div className="col col-12" >

                                          <div className="col col-4">
                                            <div className="t-Form-labelContainer">
                                              <label id="progenitor1Nom_LABEL" htmlFor="progenitor1Nom" className="t-Form-label">Tutor legal/Progenitor 1*</label>
                                            </div>


                                            <FormInputText id="progenitor1Nom" name="progenitor1Nom" col="col-12" label="Nom i cognoms" value={progenitor1Nom} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Nom} error={errors.progenitor1Nom} />
                                            <FormInputText id="progenitor1iddocument" name="progenitor1iddocument" col="col-6" label="DNI/NIE/Passaport" value={progenitor1iddocument} obligatori={true} size="20" maxLength="20" onChange={setProgenitor1iddocument} error={errors.progenitor1iddocument} />

                                          {config.conviuAmbProgenitor && (
                                            <div className="col col-6">
                                              <br></br>
                                              <div className="t-Form-labelContainer" className="t-Form-label">
                                              <input type="checkbox" id="progenitor1Conviu" name="progenitor1Conviu" value={progenitor1Conviu} checked={progenitor1Conviu === "1" ? true : false} onChange={(t) => { setProgenitor1Conviu(t.target.value === "1" ? "0" : "1") }}/>
                                                <label htmlFor="progenitor1Conviu">
                                                  Convius amb aquest progenitor?
                                                </label>
                                              </div>
                                              <span id="progenitor1Conviu_ERROR" className="a-Form-error">{errors.progenitor1Conviu}</span>
                                            </div>)}

                                             <div className="col col-12"></div>
                                            <DropZone id="progenitor1IDFrontFile" file={progenitor1IDFrontFile} onChange={setProgenitor1IDFrontFile} label={"DNI/NIE/Passaport (davant)" + (adjuntarArxiusNoObligatori ? "" : "*")} labelDrop="adjuntar imatge" error={errors.progenitor1IDFrontFile}  handleFileError={ (msg) =>handleFileError('progenitor1IDFrontFile',msg) } />
                                            <DropZone id="progenitor1IDBackFile" file={progenitor1IDBackFile} onChange={setProgenitor1IDBackFile} label={"DNI/NIE/Passaport (darrere)" + (adjuntarArxiusNoObligatori ? "" : "*")} labelDrop="adjuntar imatge" error={errors.progenitor1IDBackFile}  handleFileError={ (msg) =>handleFileError('progenitor1IDBackFile',msg) } />
                                            <FormInputText id="progenitor1Telefon" name="progenitor1Telefon" col="col-12" label="Telèfon" value={progenitor1Telefon} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Telefon} error={errors.progenitor1Telefon} />
                                            <FormInputText id="progenitor1Email" name="progenitor1Email" col="col-12" label="E-mail" value={progenitor1Email} obligatori={true} size="30" maxLength="50" onChange={setProgenitor1Email} error={errors.progenitor1Email} />
                                            <FormTextArea id="progenitor1Observacions" name="progenitor1Observacions" label="Horari de contacte / Observacions" value={progenitor1Observacions} obligatori={true} rows="5" cols="80" maxLength="1000" onChange={setProgenitor1Observacions} error={errors.progenitor1Observacions} />
                                          </div>

                                          <div className="col col-4">
                                            <div className="t-Form-labelContainer">
                                              <label id="progenitor2Nom_LABEL" htmlFor="progenitor2Nom" className="t-Form-label">Tutor legal/Progenitor 2</label>
                                            </div>

                                            <FormInputText id="progenitor2Nom" name="progenitor2Nom" col="col-12" label="Nom i cognoms" value={progenitor2Nom} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Nom} error={errors.progenitor2Nom} />
                                            <FormInputText id="progenitor2iddocument" name="progenitor2iddocument" col="col-6" label="DNI/NIE/Passaport" value={progenitor2iddocument} obligatori={false} size="20" maxLength="20" onChange={setProgenitor2iddocument} error={errors.progenitor2iddocument} />

                                          {config.conviuAmbProgenitor && (
                                            <div className="col col-6">
                                              <br></br>
                                              <div className="t-Form-labelContainer" className="t-Form-label">
                                              <input type="checkbox" id="progenitor2Conviu" name="progenitor2Conviu" value={progenitor2Conviu} checked={progenitor2Conviu === "1" ? true : false} onChange={(t) => { setProgenitor2Conviu(t.target.value === "1" ? "0" : "1") }} />
                                                <label htmlFor="progenitor2Conviu">
                                                  Convius amb aquest progenitor?
                                                </label>
                                              </div>
                                              <span id="progenitor2Conviu_ERROR" className="a-Form-error">{errors.progenitor2Conviu}</span>
                                            </div>)}

                                             <div className="col col-12"></div>
                                            <DropZone id="progenitor2IDFrontFile" file={progenitor2IDFrontFile} onChange={setProgenitor2IDFrontFile} label="DNI/NIE/Passaport (davant)" labelDrop="adjuntar imatge" error={errors.progenitor2IDFrontFile}  handleFileError={ (msg) =>handleFileError('progenitor2IDFrontFile',msg) }  />
                                            <DropZone id="progenitor2IDBackFile" file={progenitor2IDBackFile} onChange={setProgenitor2IDBackFile} label="DNI/NIE/Passaport (darrere)" labelDrop="adjuntar imatge" error={errors.progenitor2IDBackFile}  handleFileError={ (msg) =>handleFileError('progenitor2IDBackFile',msg) }  />
                                            <FormInputText id="progenitor2Telefon" name="progenitor2Telefon" col="col-12" label="Telèfon" value={progenitor2Telefon} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Telefon} error={errors.progenitor2Telefon} />
                                            <FormInputText id="progenitor2Email" name="progenitor2Email" col="col-12" label="E-mail" value={progenitor2Email} obligatori={false} size="30" maxLength="50" onChange={setProgenitor2Email} error={errors.progenitor2Email} />
                                            <FormTextArea id="progenitor2Observacions" name="progenitor2Observacions" label="Horari de contacte / Observacions" value={progenitor2Observacions} obligatori={false} rows="5" cols="80" maxLength="1000" onChange={setProgenitor2Observacions} error={errors.progenitor2Observacions} />

                                          </div>


                                            {/* console.log("CE OBL",config.contacteEmergenciaObligatori && majorEdat, config.contacteEmergenciaObligatori, majorEdat, edat)  */}

                                          <ContacteEmergencia col="col-4"
                                            label="Telèfon en cas d'emergència"
                                            values={{ nom: contacteEmergenciaNom, relacio: contacteEmergenciaRelacio, telefon: contacteEmergenciaTelefon }}
                                            onChanges={{ nom: setContacteEmergenciaNom, relacio: setContacteEmergenciaRelacio, telefon: setContacteEmergenciaTelefon }}
                                            errors={errors} />

                                        </div>

                                      </div>
                                    </React.Fragment>)}

                                </div>

                                <div className="row">
                                  <FormInputText id="telefonmobil" name="telefonmobil" col="col-3" label="Telèfon mòbil alumne/a" value={telefonMobil} obligatori={(config.telefonObligatori && telefonMobilObligatori) } size="10" maxLength="10" onChange={handleTelefonMobil} error={errors.telefon} />
                                  <FormInputText id="telefonfix" name="telefonfix" col="col-3" label="Telèfon fix alumne/a" value={telefonFix} obligatori={(config.telefonObligatori && telefonFixObligatori) } size="10" maxLength="10" onChange={handleTelefonFix} error={errors.telefon} />
                                  <FormInputText id="email" name="email" col="col-3" label="Email alumne/a" value={email} obligatori={true || majorEdat} size="10" maxLength="50" onChange={setEmail} error={errors.email} />
                                </div>

                                <div className="row">

                                  <FormInputText id="adreca" name="adreca" col="col-5" label="Adreça habitual" value={adreca} obligatori={true} size="30" maxLength="50" onChange={setAdreca} error={errors.adreca} />
                                  <FormInputText id="codipostal" name="codipostal" col="col-1" label="Codi postal" value={codiPostal} obligatori={true} size="10" maxLength="10" onChange={setCodiPostal} error={errors.codiPostal} />

                                </div>
                                <div className="row">

                                  <FormInputText id="poblacio" name="poblacio" col="col-3" label="Població de residència" value={poblacio} obligatori={true} size="20" maxLength="50" onChange={setPoblacio} error={errors.poblacio} />
                                  { !esMonografic && (<>
                                  <FormInputText id="provincia" name="provincia" col="col-3" label="Provincia de residència" value={provincia} obligatori={true} size="10" maxLength="10" onChange={setProvincia} error={errors.provincia} />
                                  <FormInputText id="pais" name="pais" col="col-3" label="País de residència" value={pais} obligatori={true} size="10" maxLength="10" onChange={setPais} error={errors.pais} />
                                  </>)}

                                </div>

                                <div className="row">

                                  { !esMonografic && (<>
                                  <FormInputText id="poblacioNaixement" name="poblacioNaixement" col="col-3" label="Població de naixement" value={poblacioNaixement} obligatori={true} size="20" maxLength="50" onChange={setPoblacioNaixement} error={errors.poblacioNaixement} />
                                  <FormInputText id="provinciaNaixement" name="provinciaNaixement" col="col-3" label="Provincia de naixement" value={provinciaNaixement} obligatori={true} size="10" maxLength="10" onChange={setProvinciaNaixement} error={errors.provinciaNaixement} />
                                  <FormInputText id="paisNaixement" name="paisNaixement" col="col-3" label="País de naixement" value={paisNaixement} obligatori={true} size="10" maxLength="10" onChange={setPaisNaixement} error={errors.paisNaixement} />
                                  </>)}
                                  <FormInputText id="nacionalitat" name="nacionalitat" col="col-3" label="Nacionalitat" value={nacionalitat} obligatori={true} size="10" maxLength="10" onChange={setNacionalitat} error={errors.nacionalitat} />

                                </div>

                                <br/>

                                <div className="row">

                                { !esMonografic && config.necessitatsEducativesEspecialsDesplegable &&
                                  (
                                      <>

                                  <div className="col col-3">
                                  <input type="checkbox" id="NESEYN" name="NESEYN" value={NESEYN} checked={NESEYN === "1" ? true : false} onChange={(t) => { setNESEYN(t.target.value === "1" ? "0" : "1") }} />
                                    <label className="t-Form-labelContainer" className="t-Form-label" htmlFor='NESEYN'>Estudiant amb necessitats educatives especials</label>
                                  </div>


                                    { NESEYN === "1" &&
                                    (<>
                                  <div className="col col-3 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="NESE_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="NESE" id="NESE_LABEL" className="t-Form-label">NESE: </label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>

                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="NESE" name="NESE" defaultValue={NESE} className="selectlist" size="1" onChange={(e) => setNESE(e.target.value)}>
                                                <option value=""></option>
                                                <option value="transtorns">trastorns que condicionen l'aprenentatge</option>
                                                <option value="autista">trastorns d'aspectre autista</option>
                                                <option value="nouvingut">alumnat nouvingut (últims dos anys)</option>
                                                <option value="altres">altres</option>
                                          </select></div>
                                        <span id="NESE_ERROR" className="a-Form-error">{errors.NESE}</span>
                                      </div>
                                    </div>
                                  </div>

                                    { NESE === "altres" &&
                                    <div className="col col-3 ">
                                     <FormTextArea id="NESEObservacions" name="NESEObservacions" label="Especifiqueu" value={NESEObservacions} obligatori={true} rows="5" cols="80" maxLength="1000" onChange={setNESEObservacions} error={errors.NESEObservacions} />
                                    </div>
                                    }

                                    { NESE !== "" &&
                                  <DropZone id="necessitatsEducativesEspecialsFile" file={necessitatsEducativesEspecialsFile} col="col-3" onChange={setNecessitatsEducativesEspecialsFile} label="Documentació acreditativa corresponent" labelSmall="" labelDrop="adjuntar documentació" error={errors.necessitatsEducativesEspecialsFile} handleFileError={ (msg) =>handleFileError('necessitatsEducativesEspecialsFile',msg)} obligatori={true}  />
                                    }
                                      </>)}

                                      </>
                                    ) }

                                { !esMonografic && config.necessitatsEducativesEspecials &&
                                  ( <DropZone id="necessitatsEducativesEspecialsFile" file={necessitatsEducativesEspecialsFile} col="col-3" onChange={setNecessitatsEducativesEspecialsFile} label="Estudiant amb necessitats educatives especials:" labelSmall="" labelDrop="adjuntar documentació acreditativa corresponent" error={errors.necessitatsEducativesEspecialsFile} handleFileError={ (msg) =>handleFileError('necessitatsEducativesEspecialsFile',msg) } />) }

                                { config.carnetFamiliaNombrosa && 
                                  ( <DropZone id="carnetFamiliaNombrosaFile" file={carnetFamiliaNombrosaFile} col="col-3" onChange={setCarnetFamiliaNombrosaFile} label="En cas de tenir-lo adjunteu el Carnet de Família nombrosa:" labelSmall="" labelDrop="adjuntar documentació acreditativa corresponent" error={errors.carnetFamiliaNombrosaFile} handleFileError={ (msg) =>handleFileError('  carnet familia nombrosacarnetFamiliaNombrosaFile',msg) } />) }


                                  { !esMonografic && (
                                  <div className="col col-2 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="plaIndividualitzat_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="plaIndividualitzat" id="plaIndividualitzat_LABEL" className="t-Form-label">Teniu pla individualitzat: </label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>

                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="plaIndividualitzat" name="plaIndividualitzat" defaultValue={plaIndividualitzat} className="selectlist" size="1" onChange={(e) => setPlaIndivitualitzat(e.target.value)}>
                                            <option value=""></option>
                                            <option value="1" >Sí</option>
                                            <option value="0" >No</option>
                                          </select></div>
                                        <span id="plaIndividualitzat_ERROR" className="a-Form-error">{errors.plaIndividualitzat}</span>
                                      </div>
                                    </div>
                                  </div>
                                  )}


                                { config.germansAlCentre && 
                                  ( 
                                    <FormSelectYesNo id="germansAlCentre"
                                      name="germansAlCentre"
                                      col="col-3"
                                      value={germansAlCentre}
                                      label="Teniu germans al centre?"
                                      obligatori={true}
                                      error={errors.germansAlCentre}
                                      handleChange={(e) => setGermansAlCentre(e.target.value)} />
                                )}

                                { apartatsAddicionals.includes('coneixementsPrevis') && (
                                  <>
                                    <FormSelectYesNo id="haFetAltreCursCentre"
                                      name="haFetAltreCursCentre"
                                      col="col-3"
                                      value={haFetAltreCursCentre}
                                      label="Ja has fet algun altre curs en aquest centre?"
                                      obligatori={true}
                                      error={errors.haFetAltreCursCentre}
                                      handleChange={(e) => setHaFetAltreCursCentre(e.target.value)} />

                                    <FormSelectYesNo id="teConeixementsPrevis"
                                      name="teConeixementsPrevis"
                                      col="col-3"
                                      value={teConeixementsPrevis}
                                      label="Tens coneixements previs al curs que et vols matricular?"
                                      obligatori={true}
                                      error={errors.teConeixementsPrevis}
                                      handleChange={(e) => setTeConeixementsPrevis(e.target.value)} />
                                  </>
                                )}

                                { config.llengues &&
                                  ( 
                                    <>
                                  <div className="col col-1 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="llenguesEntenc_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="llenguesEntenc" id="llenguesEntenc_LABEL" className="t-Form-label">Lleng&uuml;es que entenc:</label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>
                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="llenguesEntenc" name="llenguesEntenc" defaultValue={llenguesEntenc} className="selectlist" size="1" onChange={(e) => setLlenguesEntenc(e.target.value)}>
                                            <option value=""></option>
                                            <option value="ca">Català</option>
                                            <option value="es">Castellà</option>
                                            <option value="xx">Ambdues</option>
                                          </select></div>
                                        <span id="llenguesEntenc_ERROR" className="a-Form-error">{errors.llenguesEntenc}</span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col col-1 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="llenguesUsHabitual_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="llenguesUsHabitual" id="llenguesUsHabitual_LABEL" className="t-Form-label">Llengua d'ús habitual:</label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>
                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="llenguesUsHabitual" name="llenguesUsHabitual" defaultValue={llenguesUsHabitual} className="selectlist" size="1" onChange={(e) => setLlenguesUsHabitual(e.target.value)}>
                                            <option value=""></option>
                                            <option value="ca">Català</option>
                                            <option value="es">Castellà</option>
                                            <option value="xx">Ambdues</option>
                                            <option value="en">Anglès</option>
                                            <option value="fr">Francès</option>
                                            <option value="ar">Àrab</option>
                                            <option value="oo">Altres</option>
                                          </select></div>
                                        <span id="llenguesUsHabitual_ERROR" className="a-Form-error">{errors.llenguesUsHabitual}</span>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col col-1 ">
                                    <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="llenguesUsFamiliar_CONTAINER">
                                      <div className="t-Form-labelContainer">
                                        <label htmlFor="llenguesUsFamiliar" id="llenguesUsFamiliar_LABEL" className="t-Form-label">Llengua d'ús familiar:</label>
                                        <span className="t-Form-required">
                                          <span className="a-Icon">*</span>
                                        </span>
                                      </div>
                                      <div className="t-Form-inputContainer">
                                        <div className="t-Form-itemWrapper">
                                          <select id="llenguesUsFamiliar" name="llenguesUsFamiliar" defaultValue={llenguesUsFamiliar} className="selectlist" size="1" onChange={(e) => setLlenguesUsFamiliar(e.target.value)}>
                                            <option value=""></option>
                                            <option value="ca">Català</option>
                                            <option value="es">Castellà</option>
                                            <option value="xx">Ambdues</option>
                                            <option value="en">Anglès</option>
                                            <option value="fr">Francès</option>
                                            <option value="ar">Àrab</option>
                                            <option value="oo">Altres</option>
                                          </select></div>
                                        <span id="llenguesUsFamiliar_ERROR" className="a-Form-error">{errors.llenguesUsFamiliar}</span>
                                      </div>
                                    </div>
                                  </div>

                                  </>
                                )}
                                </div>

                              </div>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>

                  <div className="container">
                    <div className="row">
                      <div className="col col-12" align="center">
                        { 
                          /* si cal validar documents deshabilitem botó continuar fins assegurar que està validat correctament */
                        
                        ((config.validaIDdocuments && ( errorValidacioIDdocument === null || errorValidacioIDdocument === "")  )
                        || !config.validaIDdocuments ) ?
                        (<button onClick={valida} className="button">SEGÜENT</button>)
                        :
                        (<button className="button" disabled>SEGÜENT</button>)}
                      </div>
                    </div>
                  </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}